import { gql } from '@apollo/client';

export const USER_EDGES_NODE_FRAGMENT = gql`
  fragment CommunityEdgesNodeUserFields on User {
    id
    gid
    fullName
    profile {
      id
      avatarUrl
    }
    roles
  }
`;

export const COMMUNITY_USERS_EDGES_NODE_FRAGMENT = gql`
  fragment CommunityEdgesNodeFields on CommunityUser {
    id
    activatedAt
    user {
      permissions(resourceId: $communityId, resourceType: Community)
      ...CommunityEdgesNodeUserFields
    }
  }
  ${USER_EDGES_NODE_FRAGMENT}
`;

export const COMMUNITY_EDGES_FRAGMENT = gql`
  fragment CommunityEdgesFields on CommunityUserEdge {
    node {
      ...CommunityEdgesNodeFields
    }
  }
  ${COMMUNITY_USERS_EDGES_NODE_FRAGMENT}
`;

export const USER_ENROLLMENT_FRAGMENT = gql`
  fragment UserEnrollmentFields on EnrollmentConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        id
        completedAt
        course {
          id
          name
          cardImageUrl
          resumeCourseUrl
          landingPageUrl
        }
      }
    }
  }
`;

export const USERS_QUERY = gql`
  query Users(
    $communityId: ID!
    $spaceId: ID
    $searchTerm: String = ""
    $numberOfUsers: Int = 5
    $after: String
  ) {
    community(id: $communityId) {
      id
      communityUsers(
        first: $numberOfUsers
        after: $after
        filter: { active: true }
        orderBy: { field: CREATED_AT, direction: ASC }
      ) {
        totalCount
        pageInfo {
          endCursor
          startCursor
        }
        edges {
          ...CommunityEdgesFields
        }
      }
      mentionableUsers(searchTerm: $searchTerm, first: $numberOfUsers, spaceId: $spaceId) {
        edges {
          node {
            id
            user {
              id
              gid
              fullName
              profile {
                id
                avatarUrl
              }
            }
          }
        }
      }
    }
  }
  ${COMMUNITY_EDGES_FRAGMENT}
`;

export const USER_QUERY = gql`
  query User($communityId: ID!, $userId: ID!, $numOfCourses: Int, $endCursor: String) {
    community(id: $communityId) {
      id
      communityUser(userId: $userId) {
        id
        canModerate
        user {
          id
          gid
          fullName
          firstName
          roles
          profile {
            id
            avatarUrl
            company
            headline
            timezone
          }
          enrollments(
            filter: { status: COMPLETED, productStatus: [published], productVisible: true }
            orderBy: { field: COMPLETED_AT, direction: DESC }
            first: $numOfCourses
            after: $endCursor
          ) {
            ...UserEnrollmentFields
          }
        }
      }
    }
  }
  ${USER_ENROLLMENT_FRAGMENT}
`;

export const COMMUNITY_USER_SPACE_INTERACTIONS_FRAGMENT = gql`
  fragment CommunityUserSpaceInteractionsFields on CommunityUserSpaceInteraction {
    hasUnreadPosts
    lastReadAt
    communitySpace {
      id
    }
  }
`;

export const CURRENT_USER_QUERY = gql`
  query CommunityUserSpaceInteractions($communityId: ID!) {
    me {
      id
      communityUserSpaceInteractions(communityId: $communityId) {
        edges {
          node {
            ...CommunityUserSpaceInteractionsFields
          }
        }
      }
    }
  }
  ${COMMUNITY_USER_SPACE_INTERACTIONS_FRAGMENT}
`;
